import React from 'react';
import './semantic/dist/semantic.min.css';
import './App.css';
import LandingPage from './LandingPage';

const App: React.FC = () => {
  return (
    <div className="App">
      <LandingPage />
    </div>
  );
};

export default App;
